import { FormattedMessage } from 'react-intl';

import { Position } from '@sorare/core/src/__generated__/globalTypes';
import { useTypedParams } from '@sorare/core/src/lib/routing';

import CollectionCardsPage from '@sorare/gameplay/src/components/collections/CardsPage';

import { PageParams } from './__generated__/routeParams';

const groupBy = [
  {
    id: 'Forwards',
    label: (
      <FormattedMessage id="slot.forwards.name" defaultMessage="Forwards" />
    ),
    positions: [Position.basketball_forward],
  },
  {
    id: 'centers',
    label: <FormattedMessage id="slot.centers.name" defaultMessage="Centers" />,
    positions: [Position.basketball_center],
  },
  {
    id: 'guards',
    label: <FormattedMessage id="slot.guards.name" defaultMessage="Guards" />,
    positions: [Position.basketball_guard],
  },
];

const CardsPage = () => {
  const { slug, collectionSlug } = useTypedParams<PageParams>();

  if (!slug || !collectionSlug) {
    return null;
  }

  return (
    <CollectionCardsPage
      slug={slug}
      collection={collectionSlug}
      groupBy={groupBy}
    />
  );
};
export default CardsPage;
